import notificationsController from './notificationsController'

export default notificationsController



// WEBPACK FOOTER //
// ../src/controllers/notificationsController/index.js